import { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { STATUS_META, api } from "@/lib/api";
import { CheckSquare, X } from "lucide-react";
import { toast } from "sonner";

export const BulkStatusBar = ({ selectedIds, onClear, onDone }) => {
  const [status, setStatus] = useState("FULL_SUPPLY");
  const [busy, setBusy] = useState(false);

  if (selectedIds.length === 0) return null;

  const apply = async () => {
    setBusy(true);
    try {
      const r = await api.post("/purchases/bulk-status", { ids: selectedIds, status });
      toast.success(`${r.data.modified} rows updated to ${STATUS_META[status].label}`);
      onDone?.();
    } catch (e) {
      toast.error("Failed to bulk update status");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="bulk-status-bar" className="sticky bottom-4 z-30 mx-auto max-w-3xl">
      <div className="flex items-center gap-3 rounded-xl border border-amber-500/40 bg-[#111D38]/95 backdrop-blur-xl shadow-2xl p-3">
        <div className="flex items-center gap-2 pl-2 pr-3 border-r border-slate-700">
          <CheckSquare className="h-4 w-4 text-amber-400" />
          <span className="text-sm font-semibold text-slate-100">{selectedIds.length}</span>
          <span className="text-xs text-slate-400">selected</span>
        </div>
        <div className="text-xs text-slate-400 whitespace-nowrap">Set status →</div>
        <Select value={status} onValueChange={setStatus}>
          <SelectTrigger data-testid="bulk-status-select" className="bg-[#0B132B] border-slate-700 h-9 flex-1 text-xs">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="bg-[#1C2541] border-slate-700 text-slate-100">
            {Object.entries(STATUS_META).map(([k, m]) => (
              <SelectItem key={k} value={k}>{m.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Button
          size="sm"
          onClick={apply}
          disabled={busy}
          data-testid="btn-bulk-apply"
          className="bg-amber-500 hover:bg-amber-600 text-slate-900 font-semibold"
        >
          {busy ? "Applying..." : "Apply"}
        </Button>
        <button onClick={onClear} data-testid="btn-bulk-clear" className="text-slate-400 hover:text-slate-200 p-1">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
